// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__yE6Zk","tab":"Tabs_tab__mtOp2","active":"Tabs_active__0EWQH","border":"Tabs_border__uCCHi","label":"Tabs_label__xMinz"};